/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-log-cinematic-section-datascript';
const prefix = `${moduleName}.${componentName}`;

export const datascriptLogLabel = `${prefix}.datascriptLogLabel`;
export const datascriptErrorStackTraceLabel = `${prefix}.datascriptErrorStackTraceLabel`;
export const datascriptErrorLabel = `${prefix}.datascriptErrorLabel`;
export const emptyListPlaceholderLabel = `${prefix}.emptyListPlaceholderLabel`;

export const ENGLISH = {
    [datascriptLogLabel]: 'Datascript Log',
    [datascriptErrorStackTraceLabel]: 'Datascript Error Stack Trace',
    [datascriptErrorLabel]: 'Datascript Error',
    [emptyListPlaceholderLabel]: 'No datascript error trace data to show!',
};
